export { letterSpacings } from '../../dls';
